import * as yup from 'yup'

import { PASSWORD_ALLOWED_CHAR_PATTERN, PASSWORD_REGEXP } from '../constants'
import i18n from '../i18n'

const tMessage = (key: string, fallback: string) => () => i18n.t(key, fallback) || fallback

export const PasswordInputSchema = yup.object().shape({
  password: yup
    .string()
    .required(tMessage('passwordIsRequired', 'Password is required'))
    .notOneOf(
      [yup.ref('oldPassword')],
      tMessage(
        'changePasswordValidation',
        'The new password must be different from the current password',
      ),
    )
    .test(
      'invalid-characters',
      tMessage('passwordInvalidChars', 'Password contains invalid characters'),
      function (value) {
        if (!value) return true

        const disallowedChars = [...value].filter(
          (char) => !char.match(PASSWORD_ALLOWED_CHAR_PATTERN),
        )

        if (disallowedChars.length > 0) {
          const invalidCharacters =
            i18n.t('invalidCharacters', 'These characters are not allowed') ||
            'These characters are not allowed'

          return this.createError({
            message: `${invalidCharacters}: '${[...new Set(disallowedChars)].join("', '")}'`,
          })
        }

        return true
      },
    )
    .matches(
      PASSWORD_REGEXP,
      tMessage(
        'passwordValidation',
        'Password must contain between 8 and 16 symbols. Must contain at least 1 Latin uppercase letter, 1 Latin lowercase letter, 1 digit, and 1 special character !@#$%^&*()-_=+.',
      ),
    ),
})
